import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { InvestmentState } from "@/domain/investment/types";
import type { InvestmentMoveLabels, InvestmentStateLabels } from "@/domain/types/investmentPiece";

export function useInvestmentStateLabels(): InvestmentStateLabels {
  const { t } = useTranslation();
  return useMemo(
    () =>
      Object.fromEntries(
        Object.values(InvestmentState).map((state) => [state, t(`investments.status.${state}`)]),
      ) as InvestmentStateLabels,
    [t],
  );
}

export function useInvestmentMoveLabels(): InvestmentMoveLabels {
  const { t } = useTranslation();
  const states = useInvestmentStateLabels();
  return useMemo(
    () => ({
      trigger: t("investments.move.trigger"),
      triggerAria: (reference: string) => t("investments.move.trigger_aria", { reference }),
      current: (state: string) => t("investments.move.current", { state }),
      blocked: (documents: string) => t("investments.move.blocked", { documents }),
      states,
    }),
    [t, states],
  );
}
